import { isPreVerification } from '../flow-settings/settingsSelectors';
import PortalIdContainer from '../portal-id-container/PortalIdContainer';
import { updateAuth } from '../store/auth/action-creators';
import TrackerContainer from '../tracking/TrackerContainer';
export const setAuthHubless = auth => dispatch => {
  const {
    id: userId,
    email,
    firstName,
    lastName
  } = auth;
  const user = {
    firstName,
    lastName,
    email
  };

  if (isPreVerification()) {
    TrackerContainer.switchToIdentifiableTracker(email);
    TrackerContainer.setProperties({
      namespace: 'signup',
      email,
      userId
    });
  }

  dispatch(updateAuth({
    auth,
    user,
    gates: [],
    portal: {},
    portalId: null,
    userId,
    initialized: true
  }));
  return Promise.resolve({
    email
  });
};
export const setAuth = auth => dispatch => {
  const portalId = PortalIdContainer.get() || auth.hubIds[0];
  const {
    id: userId,
    email,
    firstName,
    lastName
  } = auth;
  const user = {
    firstName,
    lastName,
    email
  };

  if (isPreVerification()) {
    TrackerContainer.switchToIdentifiableTracker(email);
    TrackerContainer.setProperties({
      namespace: 'signup',
      email,
      hubId: portalId,
      userId
    });
  }

  dispatch(updateAuth({
    auth,
    user,
    portalId,
    userId,
    initialized: true
  }));
  return Promise.resolve({
    email
  });
};